import { useNavigate } from 'react-router-dom';
import errorMascot from '../assets/404-error-mascot.svg';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div
      className="tw-relative tw-w-full tw-overflow-hidden"
      style={{ backgroundColor: '#5576fa', minHeight: 'max(700px, 100vh)' }}
    >
      <img
        src={errorMascot}
        alt="Mascot bawling its eyes out"
        className="tw-absolute tw-bottom-28 tw-left-0 tw-w-full tw-block"
      />

      <div className="tw-absolute tw-inset-y-0 tw-right-0 tw-w-1/2 tw-z-5 tw-flex tw-flex-col tw-items-center tw-justify-center tw-pb-[244px] tw-px-16 tw-gap-4">
        <h1 className="tw-text-4xl tw-font-bold tw-text-white tw-m-0 tw-leading-tight tw-text-center">
          Oh no...
          <br />
          This page doesn&apos;t exist
        </h1>
        <p className="tw-text-xl tw-text-white tw-m-0">No worries! Let&apos;s get you back on track</p>
        <button
          onClick={() => navigate('/')}
          className="tw-mt-2 tw-bg-blue-500 tw-text-white tw-font-semibold tw-text-sm tw-px-8 tw-py-3 tw-rounded-full tw-border-none tw-cursor-pointer hover:tw-bg-blue-400 tw-transition-colors"
        >
          Take me home
        </button>
      </div>
    </div>
  );
};

export default NotFound;
